import {Box, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Facebook01Icon, Linkedin01Icon} from "@hugeicons/core-free-icons";
import {c, maxW} from "../landingTokens";
import logo from "../../../assets/logo.svg";

const COLUMNS = [
  {
    title: "Product",
    links: [
      {label: "How it works", href: "#builder"},
      {label: "Capabilities", href: "#caps"},
      {label: "Campaigns", href: "#campaigns"},
      {label: "Integrations", href: "#backed"},
      {label: "Specs", href: "#specs"},
    ],
  },
  {
    title: "Contact",
    links: [
      {label: "+389 75 753 932", href: "tel:+38975753932"},
      {label: "contact@ireason.mk", href: "mailto:contact@ireason.mk"},
      {label: "3rd Macedonian Brigade 37, Skopje"},
    ],
  },
  {
    title: "Community",
    links: [
      {label: "LinkedIn", href: "https://www.linkedin.com/company/ireason/", external: true, icon: Linkedin01Icon},
      {label: "Facebook", href: "https://www.facebook.com/ireasonmk", external: true, icon: Facebook01Icon},
    ],
  },
];

const linkSx = {fontSize: "13.5px", color: c.inkSoft, textDecoration: "none", lineHeight: 1.5, "&:hover": {color: c.purpleDeep}};

export const LandingFooter = () => (
  <Box component="footer" data-screen-label="Footer" sx={{borderTop: `1px solid rgba(44,43,42,0.1)`, bgcolor: c.bgSoft}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: 2.75,
        pt: 7.75,
        pb: 5,
        display: "grid",
        gridTemplateColumns: {xs: "1fr 1fr", md: "1.5fr 1fr 1fr 1fr"},
        gap: "40px 32px",
      }}
    >
      <Box>
        <Stack direction="row" alignItems="center" gap={1.1} sx={{mb: 1.25}}>
          <Box component="img" src={logo} alt="" sx={{width: 20, height: 24, objectFit: "contain"}} />
          <Typography sx={{fontSize: 18, fontWeight: 700, letterSpacing: "-0.035em"}}>OpenBrain</Typography>
        </Stack>
        <Typography sx={{fontSize: 14, color: c.inkSoft, maxWidth: 240, lineHeight: 1.5}}>
          The smarter way to handle calls.
        </Typography>
      </Box>

      {COLUMNS.map((col) => (
        <Stack key={col.title} gap={1.25}>
          <Typography sx={{fontSize: 12, fontWeight: 600, color: c.ink, mb: 0.5}}>{col.title}</Typography>
          {col.links.map((link) =>
            link.href ? (
              <Typography
                key={link.label}
                component="a"
                href={link.href}
                target={link.external ? "_blank" : undefined}
                rel={link.external ? "noreferrer" : undefined}
                sx={linkSx}
              >
                <Stack direction="row" alignItems="center" gap={0.8}>
                  {link.icon && <HugeiconsIcon icon={link.icon} size={16} aria-hidden="true" />}
                  <span>{link.label}</span>
                </Stack>
              </Typography>
            ) : (
              <Typography key={link.label} sx={{...linkSx, "&:hover": {}}}>{link.label}</Typography>
            )
          )}
        </Stack>
      ))}
    </Box>

    <Box sx={{maxWidth: maxW, mx: "auto", px: 2.75, pb: 5}}>
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        gap={2.5}
        sx={{borderTop: `1px solid rgba(44,43,42,0.1)`, pt: 2.75}}
      >
        <Typography sx={{fontSize: "11.5px", color: c.inkMuted}}>
          © {new Date().getFullYear()} OpenBrain by iReason. All rights reserved.
        </Typography>
        <Stack direction="row" gap={2.5}>
          {["Privacy", "Terms", "GDPR"].map((label) => (
            <Typography key={label} component="a" href="#contact" sx={{fontSize: "11.5px", color: c.inkMuted, textDecoration: "none", "&:hover": {color: c.purpleDeep}}}>
              {label}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Box>
  </Box>
);
